export default {
  'orderList.title': 'Order Management',
  'orderList.form.reporting': 'Is Reporting',
  'orderList.form.reporting.placeholder': 'Please select reporting status',
  'orderList.form.orderId': 'Order ID',
  'orderList.form.orderId.placeholder': 'Order ID',
  'orderList.form.merchant': 'Merchant',
  'orderList.form.merchant.placeholder': 'Merchant',
  'orderList.form.shopifyId': 'Shopify ID',
  'orderList.form.shopifyId.placeholder': 'Shopify ID',
  'orderList.form.backupShopifyId': 'Backup Store',
  'orderList.form.backupShopifyId.placeholder': 'Backup Shopify ID',
  'orderList.form.customerEmail': 'Customer Email',
  'orderList.form.customerEmail.placeholder': 'Customer Email',
  'orderList.form.search': 'Search',
  'orderList.form.reset': 'Reset',
  'orderList.form.advancedSearch': 'Advanced Search',
  'orderList.form.orderStatus': 'Order Status',
  'orderList.form.orderStatus.placeholder': 'Order Status',
  'orderList.form.paymentStatus': 'Payment Status',
  'orderList.form.paymentStatus.placeholder': 'Payment Status',
  'orderList.form.paymentMethod': 'Payment Method',
  'orderList.form.paymentMethod.placeholder': 'Please select payment method',
  'orderList.form.isSubscription': 'Is Subscription',
  'orderList.form.isSubscription.placeholder': 'Is Subscription',
  'orderList.form.pageSource': 'Page Source',
  'orderList.form.pageSource.placeholder': 'Please select page source',
  'orderList.form.dateRange': 'Date Range',
  'orderList.form.startTime': 'Start Time',
  'orderList.form.endTime': 'End Time',
  'orderList.status.created': 'Created',
  'orderList.status.createdOrPendingSync': 'Created/Pending Sync',
  'orderList.status.pending': 'Pending',
  'orderList.status.approved': 'Approved',
  'orderList.status.fulfilled': 'Fulfilled',
  'orderList.status.completed': 'Completed',
  'orderList.status.cancelled': 'Cancelled',
  'orderList.status.failed': 'Failed',
  'orderList.status.abnormal': 'Abnormal',
  'orderList.status.pendingSync': 'Pending Sync',
  'orderList.status.refunded': 'Refunded',
  'orderList.paymentStatus.createOrder': 'Unpaid',
  'orderList.paymentStatus.paid': 'Paid',
  'orderList.paymentStatus.pending': 'Pending',
  'orderList.paymentStatus.pendingPay': 'Processing Payment',
  'orderList.paymentStatus.failed': 'Failed',
  'orderList.paymentStatus.refunded': 'Refunded',
  'orderList.operation.export': 'Export',
  'orderList.operation.statistics': 'Order Statistics',
  'orderList.export.viewProgress': 'View Export Progress',
  'orderList.export.panelTitle': 'Export Tasks',
  'orderList.export.refresh': 'Refresh',
  'orderList.export.minimize': 'Minimize',
  'orderList.export.empty': 'No export tasks yet',
  'orderList.export.rows': 'rows',
  'orderList.export.createdAt': 'Created at',
  'orderList.export.download': 'Download',
  'orderList.export.downloadStarted': 'Download started',
  'orderList.export.downloadUnavailable': 'Download URL unavailable',
  'orderList.export.taskCreated':
    'Export task created. Track progress at the bottom-right',
  'orderList.export.createFailed': 'Failed to create export task',
  'orderList.export.failedHint': 'Export failed, please retry',
  'orderList.export.goRecords': 'Go to Export Records',
  'orderList.export.status.pending': 'Queued',
  'orderList.export.status.processing': 'Exporting',
  'orderList.export.status.success': 'Done',
  'orderList.export.status.failed': 'Failed',
  'orderList.actions.refresh': 'Refresh',
  'orderList.actions.density': 'Density',
  'orderList.actions.columnSetting': 'Column Settings',
  'orderList.columns.index': '#',
  'orderList.columns.orderNumber': 'Order Number',
  'orderList.columns.shopName': 'Shop Name',
  'orderList.columns.merchant': 'Merchant',
  'orderList.columns.shopifyId': 'Shopify ID',
  'orderList.columns.backupShopifyId': 'Backup Shopify ID',
  'orderList.columns.email': 'Customer Email',
  'orderList.columns.productName': 'Product Name',
  'orderList.columns.quantity': 'Quantity',
  'orderList.columns.subtotal': 'Subtotal',
  'orderList.columns.shipping': 'Shipping',
  'orderList.columns.tax': 'Tax',
  'orderList.columns.total': 'Total',
  'orderList.columns.usdTotal': 'USD Total',
  'orderList.columns.currency': 'Currency',
  'orderList.columns.paymentMethod': 'Payment Method',
  'orderList.columns.paymentStatus': 'Payment Status',
  'orderList.columns.orderStatus': 'Order Status',
  'orderList.columns.reporting': 'Is Reporting',
  'orderList.columns.isSubscription': 'Is Subscription',
  'orderList.columns.createdAt': 'Created At',
  'orderList.isSubscription.yes': 'Yes',
  'orderList.isSubscription.no': 'No',
  'orderList.reporting.yes': 'Yes',
  'orderList.reporting.no': 'No',
  'orderList.columns.operations': 'Operations',
  'orderList.columns.operations.view': 'View',
  'orderList.columns.operations.forceComplete': 'Sync',
  'orderList.columns.operations.forceCompleteSuccess':
    'Order synced successfully',
  'orderList.columns.operations.forceCompleteError': 'Failed to sync order',
  'orderList.size.mini': 'Mini',
  'orderList.size.small': 'Small',
  'orderList.size.medium': 'Medium',
  'orderList.size.large': 'Large',
  'orderList.detail.title': 'Order Details',
  'orderList.detail.orderStatus': 'Order Status',
  'orderList.detail.paymentStatus': 'Payment Status',
  'orderList.detail.orderInfo': 'Order Information',
  'orderList.detail.orderId': 'Order ID',
  'orderList.detail.paymentMethod': 'Payment Method',
  'orderList.detail.shopifyId': 'Shopify ID',
  'orderList.detail.currency': 'Currency',
  'orderList.detail.customerInfo': 'Customer Information',
  'orderList.detail.customerName': 'Customer Name',
  'orderList.detail.customerEmail': 'Customer Email',
  'orderList.detail.productInfo': 'Product Information',
  'orderList.detail.sku': 'SKU',
  'orderList.detail.quantity': 'Quantity',
  'orderList.detail.unitPrice': 'Unit Price',
  'orderList.detail.subtotal': 'Subtotal',
  'orderList.detail.amountInfo': 'Amount Information',
  'orderList.detail.shipping': 'Shipping',
  'orderList.detail.tax': 'Tax',
  'orderList.detail.handling': 'Handling Fee',
  'orderList.detail.tip': 'Tip',
  'orderList.detail.originTotal': 'Original Total',
  'orderList.detail.total': 'Total',
  'orderList.detail.addressInfo': 'Address Information',
  'orderList.detail.shippingAddress': 'Shipping Address',
  'orderList.detail.billingAddress': 'Billing Address',
  'orderList.detail.timeInfo': 'Time Information',
  'orderList.detail.createdAt': 'Created At',
  'orderList.detail.updatedAt': 'Updated At',
  'orderList.productDetail.title': 'Product Details',
  'orderList.productDetail.unitPrice': 'Unit Price',
  'orderList.productDetail.quantity': 'Quantity',
  'orderList.productDetail.subtotal': 'Subtotal',
  'orderList.productDetail.detailInfo': 'Detailed Information',
  'orderList.productDetail.weight': 'Weight',
  'orderList.productDetail.variantId': 'Variant ID',
  'orderList.detail.adParams': 'Ad Parameters',
  'orderList.detail.loadError': 'Failed to fetch order details',
  'orderList.detail.phone': 'Phone',
  'orderList.detail.discountCode': 'Discount Code',
  'orderList.detail.cartToken': 'Cart Token',
  'orderList.detail.pageSource': 'Page Source',
  'orderList.detail.paymentProcess': 'Payment Process',
  'orderList.detail.paymentGateway': 'Payment Gateway',
  'orderList.detail.paymentAmount': 'Payment Amount',
  'orderList.detail.clientIp': 'Client IP',
  'orderList.detail.paymentMessage': 'Payment Message',
  'orderList.detail.paymentError': 'Payment Error',
  'orderList.detail.paymentConfig': 'Payment Config',
  'orderList.detail.gatewayType': 'Gateway Type',
  'orderList.detail.gatewayAlias': 'Gateway Alias',
  'orderList.detail.paymentResult': 'Payment Result',
  'orderList.detail.transactionToken': 'Transaction Token',
  'orderList.detail.transactionState': 'Transaction State',
  'orderList.detail.transactionMessage': 'Transaction Message',
  'orderList.detail.transactionSucceeded': 'Transaction Succeeded',
  'orderList.detail.failureReason': 'Failure Reason',
  'orderList.detail.lastErrorAt': 'Last Error At',
  'orderList.detail.paymentInfo': 'Payment Information',
  'orderList.detail.spreedlyOrderStatus': 'Spreedly Order Status',
  'orderList.detail.paypalOrderStatus': 'PayPal Order Status',
  'orderList.detail.paypalOrderId': 'PayPal Order ID',
  'orderList.detail.capturePaypal': 'Capture Now',
  'orderList.detail.capturePaypalSuccess': 'PayPal order captured successfully',
  'orderList.detail.capturePaypalError': 'Failed to capture PayPal order',
  'orderList.detail.checkoutInfo': 'Checkout Information',
  'orderList.detail.funnelId': 'Funnel ID',
  'orderList.detail.zoneId': 'Zone ID',
  'orderList.detail.checkoutIp': 'Checkout IP',
  'orderList.detail.checkoutLanguage': 'Checkout Language',
  'orderList.detail.sourceUrl': 'Source URL',
  'orderList.detail.shopifyTags': 'Shopify Tags',
  'orderList.detail.customAttributes': 'Custom Attributes',
  'orderList.detail.attributeKey': 'Attribute Key',
  'orderList.detail.attributeValue': 'Attribute Value',
  'orderList.detail.processTime': 'Process Time',
  'orderList.detail.shopifyDraftOrderId': 'Shopify Draft Order ID',
  'orderList.detail.pixelReporting': 'Pixel Reporting Status',
  'orderList.detail.tiktokReporting': 'TikTok Reporting',
  'orderList.detail.facebookReporting': 'Facebook Reporting',
  'orderList.detail.facebookError': 'Facebook Error',
  'orderList.detail.newsbreakReporting': 'Newsbreak Reporting',
  'orderList.detail.newsbreakError': 'Newsbreak Error',
  'orderList.detail.success': 'Success',
  'orderList.detail.failed': 'Failed',
};
